const swiper1 = new Swiper(".js-ps-gallery", {
    loop: true,
    speed: 12000,
    spaceBetween: 30,
    allowTouchMove: true,
    slidesPerView: 'auto',
    freeMode: true,
    autoplay: {
      delay: 0,
    },
});

const swiper2 = new Swiper(".js-fade", {
    loop: true,
    speed: 3000,
    effect: 'fade',
    allowTouchMove: false,
    slidesPerView: 'auto',
    freeMode: true,
    autoplay: {
      delay: 200,
    },
});

//tab
var tabLinks = document.querySelectorAll('.js-tab');
tabLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
        event.preventDefault();

        tabLinks.forEach(function(item) {
            item.classList.remove('is-active');
        });
        document.querySelectorAll('.js-tab-contents').forEach(function(content) {
            content.classList.remove('is-active');
        });

        link.classList.add('is-active');
        var tabId = link.getAttribute('data-tab');
        document.getElementById(tabId).classList.add('is-active');
    });
});

//toggle

$(function(){
  $('.js-toggle-button').click(function(){
    $(this).toggleClass('is-open');
    $(this).next('nav').slideToggle();
  });
});

